/** Copyright 2024 SAP SE or an SAP affiliate company. All rights reserved. */
import { Icon, Text, FlexBox, FlexBoxJustifyContent, FlexBoxDirection, FlexBoxAlignItems } from '@ui5/webcomponents-react';
import React from 'react';
import { uiButtonIconMediumSize, uiFullWidth } from '../../Styling/Theme/Theme';
import { ThemingParameters } from '@ui5/webcomponents-react-base';

interface TabProps {
    index: number;
    icon: string;
    title: string;
    selectedTab: number;
    handleSelectedTab: (index: number) => void;
    body?: string;
}
const Tab: React.FC<TabProps> = ({ index, icon, title, selectedTab, handleSelectedTab, body }) => {
    const handleTabClick = (index: number) => {
        handleSelectedTab(index);
    };

    return (
        <FlexBox
            key={index}
            data-testId="modal-tab"
            direction={FlexBoxDirection.Row}
            alignItems={FlexBoxAlignItems.Center}
            justifyContent={FlexBoxJustifyContent.Start}
            className={`content_tab ${selectedTab === index ? 'selected' : ''}`}
            onClick={() => handleTabClick(index)}
        >
            <Text style={{ cursor: 'inherit' }}>
                <Icon
                    name={`sap-icon://${icon}`}
                    style={{
                        width: uiButtonIconMediumSize.width,
                        height: uiButtonIconMediumSize.height,
                    }}
                />
            </Text>

            <FlexBox
                direction={FlexBoxDirection.Column}
                style={{
                    gap: ThemingParameters.sapContent_Margin_Tiny,
                    width: 'auto',
                    paddingLeft: ThemingParameters.sapContent_Padding_M,
                }}
            >
                <Text data-testId="modal-tab-title" style={{ cursor: 'inherit' }}>
                    {title}
                </Text>
                {body ? (
                    <Text data-testId="modal-tab-body" style={{ color: ThemingParameters.sapContent_LabelColor, cursor: 'inherit' }}>
                        {body}
                    </Text>
                ) : null}
            </FlexBox>
        </FlexBox>
    );
};

export default Tab;
